import classNames from "classnames";
import React from "react";

interface Props {
  count: number
}

const ReminderStatus = ({ count }: Props) => {
  const className = classNames("s1_tag small", {
    "gray-bg": count === 0,
    "orange-bg": count > 0 && count < 3,
    "red-bg": count === 3
  });

  return <div className={className}>
    <div className="flex">
      <div>
        <i style={{ fontSize: 8 }} className="icon-bell" />
      </div>
      <div className="s1_smaller" style={{ width: 12, textAlign: "right" }}>
        {count}
      </div>
    </div>
  </div>;
};

export default ReminderStatus;